import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../api/client';
import Logo from '../components/Logo';
import ThemeToggle from '../components/ThemeToggle';

export default function ResetPassword() {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const token = searchParams.get('token');

	const [form, setForm] = useState({ new_password: '', confirm_password: '' });
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (form.new_password !== form.confirm_password) {
			setError('Passwords do not match');
			return;
		}
		if (form.new_password.length < 8) {
			setError('Password must be at least 8 characters');
			return;
		}
		setLoading(true);
		setError(null);
		try {
			await api.post('/auth/reset-password', {
				token,
				new_password: form.new_password,
			});
			navigate('/login?reset=success');
		} catch (err) {
			setError(err.response?.data?.detail ?? err.message);
		} finally {
			setLoading(false);
		}
	};

	const inputClass =
		'border border-gray-200 dark:border-white/10 bg-white dark:bg-brand-dark-bg rounded-lg px-4 py-2.5 text-sm text-gray-900 dark:text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-violet dark:focus:ring-brand-violet-on-dark w-full';

	return (
		<div className='min-h-screen bg-brand-light-bg dark:bg-brand-dark-bg flex flex-col'>
			<nav className='flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-white/10'>
				<Logo className='h-12' />
				<ThemeToggle />
			</nav>
			<div className='flex-1 flex items-center justify-center px-4'>
				<div className='bg-white dark:bg-brand-dark-surface rounded-2xl border border-gray-100 dark:border-white/10 p-8 w-full max-w-sm'>
					<h1 className='text-2xl font-bold text-gray-900 dark:text-white mb-1'>
						Set new password
					</h1>
					<p className='text-gray-400 text-sm mb-6'>
						Choose a strong password for your account.
					</p>
					{error && <p className='text-red-500 text-sm mb-4'>{error}</p>}
					{!token ? (
						<p className='text-red-500 text-sm'>
							Invalid reset link.{' '}
							<Link
								to='/forgot-password'
								className='text-brand-violet dark:text-brand-violet-on-dark hover:underline'
							>
								Request a new one
							</Link>
							.
						</p>
					) : (
						<form
							onSubmit={handleSubmit}
							className='flex flex-col gap-4'
						>
							<input
								type='password'
								required
								value={form.new_password}
								onChange={(e) =>
									setForm({ ...form, new_password: e.target.value })
								}
								placeholder='New password (min 8 chars)'
								className={inputClass}
							/>
							<input
								type='password'
								required
								value={form.confirm_password}
								onChange={(e) =>
									setForm({ ...form, confirm_password: e.target.value })
								}
								placeholder='Confirm new password'
								className={inputClass}
							/>
							<button
								type='submit'
								disabled={loading}
								className='bg-brand-violet text-white py-2.5 rounded-lg font-medium hover:opacity-90 disabled:opacity-50 transition'
							>
								{loading ? 'Updating...' : 'Set new password'}
							</button>
						</form>
					)}
				</div>
			</div>
		</div>
	);
}
